import React, { useState } from 'react';
import { Link } from 'raviger';
import { Button, Card, Col, ListGroup, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderMedical } from '@fortawesome/pro-solid-svg-icons';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { capitalize } from '../../utils/formatString';

function Patient(props) {

  const [showModal, setShowModal] = useState(false);

  const priorityText = {urgent:'Urgent (Red)', when_available:'When Available (Yellow)'};

  return (
    <>
    <div className="row" style={{fontSize:'0.9375rem', letterSpacing:"0.00728em", fontFamily:'"Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'}}>
      <div className="col-6 d-flex">
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body>
            <Card.Title>
              <h4 className="mb-0">
                <Row className="pe-0">
                  <Col className="pe-0">
                    <Link href={"/" + props.organization + "/" + props.incident + "/animals/" + props.animal.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>A#{props.animal.id_for_incident} - {props.animal.name||"Unknown Name"}</Link>
                    {props.animal.medical_record ? <span className="ms-auto float-end" style={{paddingRight:"15px"}}>
                      <OverlayTrigger
                        key={"medical-record"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-medical-record`}>
                            View patient medical record.
                          </Tooltip>
                        }
                      >
                        <Link href={"/" + props.organization + "/" + props.incident + "/vet/medrecord/" + props.animal.medical_record} style={{textDecoration:"none", color:"white"}}><FontAwesomeIcon icon={faFolderMedical} className="ms-1 float-end" inverse /></Link>
                      </OverlayTrigger>
                    </span> : ""}
                  </Col>
                </Row>
              </h4>
            </Card.Title>
            <p className="phr" />
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
              <ListGroup.Item>
                <div className="row" style={{textTransform:"capitalize"}}>
                  <span className="col-12"><b>Patient: </b>{props.animal.vet_string}</span>
                  {/* <span className="col-4"><b>Weight:</b> {data.animal_object.weight||"Unknown"}</span>
                  <span className="col-8"><b>Species:</b> {data.animal_object.species_string}</span> */}
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row" style={{textTransform:"capitalize"}}>
                  {/* <span className="col-4"><b>ID:</b> <Link href={"/" + props.organization + "/" + props.incident + "/animals/" + props.animal.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>A#{props.animal.id_for_incident}</Link></span> */}
                  <span className="col-8"><b>Vet Status:</b> {props.animal.vet_status||"Unknown"}</span>
                </div>
              </ListGroup.Item>
              {/* <ListGroup.Item style={{textTransform:"capitalize"}}>
                <div className="row">
                  <span className="col-4"><b>Weight:</b> {props.animal.weight||"Unknown"}</span>
                  <span className="col-8"><b>Species:</b> {props.animal.species_string}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row" style={{textTransform:"capitalize"}}>
                  <span className="col-4"><b>Age:</b> {capitalize(props.animal.age||"Unknown")}</span>
                  <span className="col-4"><b>Sex:</b> {props.animal.sex||"Unknown"}</span>
                  <span className="col-4"><b>Altered:</b> {props.animal.fixed === 'yes' ? "Yes" : props.animal.fixed === 'no' ? "No" : "Unknown"}</span>
                </div>
              </ListGroup.Item> */}
              <ListGroup.Item>
                <div className="row">
                  <span className="col-12">
                    <b>Medical Notes: </b>{props.animal.medical_notes ? props.animal.medical_notes : "N/A"}
                  </span>
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
      {props.vet_request ? <div className="col-6 d-flex ps-0">
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body>
            <Card.Title>
              <h4 className="mb-0">
                Vet Request
              </h4>
            </Card.Title>
            <p className="phr" />
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-5"><b>ID: </b><Link href={"/" + props.organization + "/" + props.incident + "/vet/vetrequest/edit/" + props.vet_request.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>VR#{props.vet_request.id_for_incident}</Link></span>
                  <span className="col-7"><b>Priority: </b>{priorityText[props.vet_request.priority]}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <b>Presenting Complaints:</b> {props.vet_request.complaints_text || "None"}
              </ListGroup.Item>
              <ListGroup.Item>
                <b>Concern:</b> {props.vet_request.concern || "N/A"}
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div> : props.medical_plan ?
      <div className="col-6 d-flex ps-0">
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body>
            <Card.Title>
              <h4 className="mb-0">
                Medical Plan
              </h4>
            </Card.Title>
            <p className="phr"/>
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px", whiteSpace:"pre-line"}}>
              <ListGroup.Item>
                {props.medical_plan}
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card></div> : ""}
      {props.vet_request && props.vet_request.caution ? <Col><div className="alert text-center w-100" style={{fontSize:"16px", marginBottom:"-5px", backgroundColor:"#f6cd29"}}><FontAwesomeIcon icon={faTriangleExclamation} className="me-1" inverse />Use caution when interacting with this animal.<FontAwesomeIcon icon={faTriangleExclamation} className="ms-1" inverse /></div></Col> : ""}
    </div>
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Medical Notes</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.animal.medical_notes}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => setShowModal(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default Patient;